import React from 'react';
import { Box, Heading, Page, PageContent } from 'grommet';
import { useRouteError } from 'react-router-dom';

const ErrorPage = () => {
    let error = useRouteError();
    console.log(error);
    return (
        <Page>
            <PageContent>
                <Heading>Oops! An error occurred</Heading>
                <Box>{error.message}</Box>
            </PageContent>
        </Page>
    );
};

export default ErrorPage;
